import { render, staticRenderFns } from "./CorporationsForm.vue?vue&type=template&id=0b83f778&scoped=true"
import script from "./CorporationsForm.vue?vue&type=script&lang=js"
export * from "./CorporationsForm.vue?vue&type=script&lang=js"
import style0 from "./CorporationsForm.vue?vue&type=style&index=0&id=0b83f778&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b83f778",
  null
  
)

export default component.exports